<template>
    <div id="vehiclemodel_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Fuel Island Product List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddMod" class="btn btn-primary pull-right" v-bind:to="{name: 'FuelIslandProductCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content fuel-island-list">
                        <data-table-filter-config :moduleName="'islandProductList'" ref="filterIslandProduct" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'islandProductList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="fuelIslandProductList"
                                    mode="remote"
                                    title="FuelIslandProduct"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: canDeleteMod,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Island Product" v-if="canUpdateMod == true" class="fp-edit" v-bind:to="{name: 'FuelIslandProductEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="canDeleteMod" id="deleteVehicleModelBtn" v-on:click.prevent="islandProductDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "FuelIslandProductList",
        metaInfo() {
            return {title: "Fuel Island Product List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true
                },
                {
                    label: 'Item',
                    field: 'item',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false
                },
                {
                    label: 'Cost Method',
                    field: 'cost_method',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        filterDropdownItems: ['Entered','Average Cost']
                    }
                },
                {
                    label: 'Capacity',
                    field: 'capacity',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    type:'number'
                },
                {
                    label: 'Current Inventory',
                    field: 'current_inventory',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false
                },
                {
                    label: 'Measurement Unit',
                    field: 'measurement_unit',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Tank No',
                    field: 'tank_no',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                },
                {
                    label: 'Fuel Tax',
                    field: 'fuel_tax',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        filterDropdownItems: ['Yes','No'],
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            canDeleteMod: false,
            loading:false,
            canAddMod:false,
            canUpdateMod:false,
            action:'list',
            pageKey:"_fuel_island_product_list_",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_fuel_island_product') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_fuel_island_product') {
                            self.canDeleteMod = true;
                        }
                        if (permissions[i].name == 'add_fuel_island_product') {
                            self.canAddMod = true;
                            self.canUpdateMod = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();
        },
        methods: {
          cancelAll: function (cancelAll) {
              this.$refs.fuelIslandProductList.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var data = this.$refs['fuelIslandProductList'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['fuelIslandProductList'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-island-product/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$refs.filterIslandProduct.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.action == 'delete'){
                            self.generateStatusCodeMessage(jqXHR,false,'load-island-product-delete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'load-island-product-list')
                        }

                    }
                });
            },
            islandProductDelete() {
              var self = this;
              self.$swal({
                    title: 'Are you sure that you want to delete this Fuel Island Product?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();
                    } else {
                      console.log("no");
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/FuelIslandProductList.vue